import { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const LanguageContext = createContext(null);

const DEFAULT_TRANSLATIONS = {
  welcome: "Welcome",
  dashboard: "Dashboard",
  tests: "Tests",
  bookings: "My Bookings",
  results: "Lab Results",
  profile: "Profile",
  wallet: "Wallet",
  logout: "Sign Out",
  login: "Sign In",
  register: "Register",
  book_test: "Book Test",
  view_results: "View Results",
  payment_success: "Payment Successful",
  payment_failed: "Payment Failed",
  currency: "Currency",
  language: "Language",
  settings: "Settings",
  dark_mode: "Dark Mode",
  light_mode: "Light Mode"
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => {
    const saved = localStorage.getItem('medlab_language');
    return saved || 'en';
  });
  const [translations, setTranslations] = useState(DEFAULT_TRANSLATIONS);
  const [languages, setLanguages] = useState([
    { code: 'en', name: 'English', flag: '🇬🇧' },
    { code: 'yo', name: 'Yorùbá', flag: '🇳🇬' },
    { code: 'ig', name: 'Igbo', flag: '🇳🇬' },
    { code: 'ha', name: 'Hausa', flag: '🇳🇬' }
  ]);

  useEffect(() => {
    localStorage.setItem('medlab_language', language);
    fetchTranslations(language);
  }, [language]);

  useEffect(() => {
    fetchLanguages();
  }, []);

  const fetchTranslations = async (lang) => {
    try {
      const response = await axios.get(`${API}/translations/${lang}`);
      setTranslations(response.data.translations);
    } catch (error) {
      console.error('Failed to fetch translations:', error);
      setTranslations(DEFAULT_TRANSLATIONS);
    }
  };

  const fetchLanguages = async () => {
    try {
      const response = await axios.get(`${API}/languages`);
      setLanguages(response.data);
    } catch (error) {
      console.error('Failed to fetch languages:', error);
    }
  };

  const t = (key) => {
    return translations[key] || key;
  };

  const value = {
    language,
    setLanguage,
    translations,
    languages,
    t,
  };

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
};
